/* eslint-disable react/forbid-prop-types */
import React, { Component } from "react";
import PropTypes from "prop-types";
import styles from "./DropoffImageWidget.module.css";
import { deliveryStatuses } from "../../shared/constants/order";
import { isOrderExpired } from "../../shared/utilities/common";

class DropoffImageWidget extends Component {

  renderDropoffImage = (deliveryImageUrl) => {
    const { className } = this.props;
    return (
      <div className={[styles.dropoffImageContainer, className].join(' ')}>
        <div className={styles.dropoffImageTitle}>Dropoff Location</div>
        <div className={styles.dropoffImage}>
          <img src={deliveryImageUrl} alt="" />
        </div>
      </div>
    );
  }

  isDropoffImageShouldBeRendered = () => {
    const { order } = this.props;
    const isExpired = isOrderExpired(order);
    return order?.deliveryStatus?.deliveryImageUrl
      && order?.status?.status >= deliveryStatuses.DRIVER_RETURNED
      && !isExpired;
  }

  render() {
    const { order } = this.props;
    return this.isDropoffImageShouldBeRendered()
      ? this.renderDropoffImage(order.deliveryStatus.deliveryImageUrl)
      : null;
  }

}

DropoffImageWidget.propTypes = {
  order: PropTypes.object.isRequired,
  className: PropTypes.string,
};

DropoffImageWidget.defaultProps = {
  className: '',
};
  
export default DropoffImageWidget;
